module.exports = __webpack_public_path__ + "static/img/coder.30a0a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coder.png
// module id = QBpc
// module chunks = 1